import { transformConstants } from 'helpers/transformConstants';

const componentEventConstants = transformConstants([
  // INGREDIENT CATEGORY
  'MOKAPOS_INGREDIENT_CATEGORY_CHANGE_OUTLET',
  'MOKAPOS_INGREDIENT_CATEGORY_SELECT',
  'MOKAPOS_INGREDIENT_CATEGORY_CREATE_ALL_OUTLET',
  'MOKAPOS_INGREDIENT_CATEGORY_CREATE_ONE_OUTLET',
  'MOKAPOS_INGREDIENT_CATEGORY_DELETE',
  'MOKAPOS_INGREDIENT_CATEGORY_ASSIGN',

  // INVENTORY TRANSFER
  'MOKAPOS_INVENTORY_TRANSFER_EXPORT',

  // INGREDIENT LIBRARY
  'MOKAPOS_INGREDIENT_LIBRARY_EXPORT',
  'MOKAPOS_INGREDIENT_LIBRARY_START_TRIAL',
  'MOKAPOS_INGREDIENT_LIBRARY_IMPORT_INGREDIENT',
  'MOKAPOS_INGREDIENT_LIBRARY_CREATE_SFI_LIBRARY',

  // PAYMENT CONFIGURATION
  'MOKAPOS_PAYMENT_CONFIGURATION_ADD',

  // REGISTRATION
  'MOKAPOS_REGISTRATION_CREATE_EMAIL',
  'MOKAPOS_REGISTRATION_BUSINESS_INFORMATION_COMPLETED',

  // REPORTS
  'MOKAPOS_REPORT_DISCOUNT_EXPORT',
  'MOKAPOS_REPORT_COLLECTED_EXPORT',
  'MOKAPOS_REPORT_CATEGORY_SALES_EXPORT',
]);

export { componentEventConstants };
